import React from 'react';
import logo from './logo.svg';
import './App.css';
import { MainScreen } from './Components/MainScreen';
// import { LoginScreen, LoginScreenMode } from './Components/LoginScreen';
// import { ResetPasswordScreen } from './Components/ResetPasswordScreen';
import { BaseScreen } from './Components/BaseScreen';
// import { MenuScreenContent } from './Components/MenuScreenContent';
import { LoadingScreen } from './Components/LoadingScreen';
import { ProxyLoginResp, requestPasswordReset, requestProxyLogin, sendMessageToProxy } from './Misc/utils';
import { AppConfig } from './configDef';
import { ProxyLang } from './Localization/locDef';
import { produce } from 'immer';
// import { BeginEvaluationScreenContent, StatusEvaluationScreenContent, StatusLessonsScreenContent } from './Components/StatusScreenContents';
// import { DoEvaluationScreenContent } from './Components/DoEvaluationScreenContent';
// import { ChooseAvatarScreen } from './Components/ChooseAvatarScreen';
import { PosteScreenWrapper } from './Misc/style';


export type AvatarType = 'male' | 'female'
export type ThemeType = 'light' | 'dark'

export type AppState = {
  _tag: 'logged_out',
} | {
  _tag: 'logging',
} | {
  _tag: 'logged_in',
  username: string,
  password: string,
  proxyLoginResp: ProxyLoginResp,
  // coursePercentages: CoursePercentages,
  screen: ScreenType,
  avatarType: null | AvatarType,
  theme: ThemeType,
} | {
  _tag: 'reset_password',
  username: string,
  password: string,
}

type ScreenType = {
    _tag: 'menu',
  } | {
    _tag: 'course_lessons',
    courseName: string,
    lessonName: null | string,
  } | {
    _tag: 'course_evaluation',
    coursename: string,
  } | {
    _tag: 'status_lessons',
  } | {
    _tag: 'status_evaluation',
  } | {
    _tag: 'begin_evaluation',
  } | {
    _tag: 'do_evaluation',
    lesson: string,
  }

type AppAction = {
  _tag: 'setWholeState',
  state: AppState,
} | {
  _tag: 'setAvatarType',
  type: null | AvatarType,
} | {
  _tag: 'switchTheme',
} | {
  _tag: 'setScreen',
  screen: ScreenType,
} | {
  _tag: 'setLessonPercentage',
  course: string,
  lesson: string,
  percentage: number,
  setNextIfCompleted: boolean,
} | {
  _tag: 'setCurrentLesson',
  lesson: null | string,
}

const appReducer: React.Reducer<AppState, AppAction> = (state, action) => {
  switch (action._tag) {
    case 'setWholeState': {
      return action.state
    }
    case 'setAvatarType': {
      if (state._tag === 'logged_in') {
        return {
          ...state,
          avatarType: action.type,
        }
      } else {
        return state
      }
    }
    case 'switchTheme': {
      if (state._tag === 'logged_in') {
        return {
          ...state,
          theme: state.theme === 'light' ? 'dark' : 'light',
        }
      } else {
        return state
      }
    }
    case 'setScreen': {
      if (state._tag === 'logged_in') {
        return {...state, screen: action.screen}
      } else {
        return state
      }
    }
    case 'setLessonPercentage': {
      if (state._tag === 'logged_in') {
        return produce(state, s => {
          // s.coursePercentages[action.course][action.lesson].percent = action.percentage
        })
      } else {
        return state
      }
    }
    case 'setCurrentLesson': {
      return produce(state, s => {
        if (s._tag === 'logged_in' && s.screen._tag === 'course_lessons') {
          s.screen.lessonName = action.lesson
        }
      })
    }
  }
}

type RawCoursePercentages = {
  [k: string]: {
    [k: string]: number
  }
}
type CoursePercentages = {
  [k: string]: {
    [k: string]: {
      percent: number
      ordinal: number
    }
  }
}

const initialAppState: AppState = {
  _tag: 'logged_in',
  username: '',
  password: '',
  proxyLoginResp: {
    access_token: '',
    session_id: '',
    
    user: {
      is_initial_user_login: false,
    },
  },
  screen: {
    _tag: 'menu',
  },
  theme: 'light',
  avatarType: "male",
}

export const AppStateContext = React.createContext<AppState>(initialAppState)
export const AppDispatchContext = React.createContext<React.Dispatch<AppAction>>(() => {})

export const DoLoginContext = React.createContext<(username: string, password: string) => void>(() => {});
 
function App() {
  const [appState, dispatch] = React.useReducer(appReducer, initialAppState)

  /*React.useEffect(() => {
    // mock risposta
    // dispatch({_tag: 'setWholeState', state: {
    //   _tag: 'logged_in',
    //   username: '',
    //   password: '',
    //   proxyLoginResp: {
    //     access_token: '',
    //     session_id: '',
    //   },
    //   coursePercentages: {
    //     "Tachipirina": {
    //        "1-Chapter 1: Introduction to Effective AI Communication": 100.0,
    //        "10-Chapter 10: Exploring Order": 0.0,
    //        "2-Chapter 2: Building Blocks: AI, Language, and Machine Learning": 100.0,
    //        "3-Chapter 3: Exploring Different Types of AI Prompts": 100.0
    //     },
    //     "Aspirina": {
    //        "1-Chapter 1: Introduction to Effective AI Communication": 100.0,
    //        "10-Chapter 10: Exploring Order": 0.0,
    //        "2-Chapter 2: Building Blocks: AI, Language, and Machine Learning": 100.0,
    //        "3-Chapter 3: Exploring Different Types of AI Prompts": 100.0
    //     }
    //   },
    //   screen: {
    //     _tag: 'menu',
    //   }
    // }})
    // return;

    const username = "teo@mail.com"
    const password = "password"

    doLogin(username, password)
  }, [])*/


  const doLogin = (username: string, password: string) => {
    dispatch({_tag: 'setWholeState', state: {_tag: 'logging'}})

    requestProxyLogin(username, password, AppConfig.proxyUrl)
      .then(loginResp => {
        const isInitialUserLogin = loginResp['user']?.['is_initial_user_login'] || false;
        if (isInitialUserLogin) {
          dispatch({_tag: 'setWholeState', state: {_tag: 'reset_password', username: username, password: password}})
        } else {
          dispatch({_tag: 'setWholeState', state: {
            _tag: 'logged_in',
            username: username,
            password: password,
            proxyLoginResp: loginResp,
            screen: {
              _tag: 'menu',
            },
            avatarType: 'female',
            theme: 'light',
          }})
        }
      })
      .catch(e => {
        window.alert("Errore durante il login, controllare che le credenziali siano corrette")
        dispatch({_tag: 'setWholeState', state: {_tag: 'logged_out'}})
      })
  }

  // const onLoginScreenConfirmation = (mode: LoginScreenMode, email: string, password: string) => {
  //   if (mode === LoginScreenMode.Login) {
  //     doLogin(email, password)
  //   } else if (mode === LoginScreenMode.RecoverSend) {
  //     throw new Error('recover not impletented')

  //     const settings: RequestInit = {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           "email": email,
  //           "password": password,
  //         }),
  //     }

  //     dispatch({_tag: 'setWholeState', state: {_tag: 'logging'}})

  //     console.log("sending signup request:")
  //     console.log(settings)
  //     fetch(AppConfig.proxyUrl + "/signup", settings)
  //     .then(resp => {
  //       console.log("received signup response:")
  //       console.log(resp)
  //       resp.json()
  //       .then(jsonResp => {
  //         if (
  //           jsonResp?.user?.email === email &&
  //           typeof jsonResp?.user?.id === 'number'
  //         ) {
  //           window.alert("Registrazione completata, reinserisci i dati per effettuare l'accesso")
  //           dispatch({_tag: 'setWholeState', state: {_tag: 'logged_out'}})
  //         } else {
  //           throw new Error()
  //         }
  //       })
  //       .catch(e => {
  //         console.log("error parsing signup response:")
  //         console.log(e)
  //         throw new Error()
  //       })
  //     })
  //     .catch(e => {
  //       console.log("signup error:")
  //       console.log(e)
  //       window.alert("Errore durante la registrazione")
  //       dispatch({_tag: 'setWholeState', state: {_tag: 'logged_out'}})
  //     })
  //   }
  // }

  // const onResetPwdConfirmation = (email: string, password: string, newPassword: string) => {
  //     requestPasswordReset(email, password, newPassword, AppConfig.proxyUrl)
  //     .then(changePasswordResp => {
  //       // console.log("changePasswordResp:", changePasswordResp)

  //       if (changePasswordResp) {
  //         window.alert("Password cambiata con successo")
  //         dispatch({_tag: 'setWholeState', state: {_tag: 'logging'}})
  //         dispatch({_tag: 'setWholeState', state: {
  //           _tag: 'logged_in',
  //           username: email,
  //           password: newPassword,
  //           proxyLoginResp: appState._tag === 'logged_in' ? appState.proxyLoginResp : { access_token: '', session_id: '', user: {is_initial_user_login:false} },
  //           coursePercentages: {},
  //           screen: {
  //             _tag: 'menu',
  //           },
  //           avatarType: null,
  //           theme: 'light',
  //         }})
  //       } else {
  //         window.alert("Errore durante il login, controllare che le credenziali siano corrette!")
  //         dispatch({_tag: 'setWholeState', state: {_tag: 'logged_out'}})
  //       }
  //     })
  //     .catch(e => {
  //       window.alert("Errore durante il login, controllare che le credenziali siano corrette")
  //       dispatch({_tag: 'setWholeState', state: {_tag: 'logged_out'}})
  //     })
  // }

  React.useEffect(() => {
    
  const requestProxyLogin = async (username: string, password: string, vampUrl: string): Promise<ProxyLoginResp> => {
    const settings: RequestInit = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "username": username,
          "password": password,
        }),
    }
    try {
        console.log("sending login request:")
        console.log(settings)
        const fetchResponse = await fetch(vampUrl + "/login", settings);
        console.log("received response:")
        console.log(fetchResponse)
        const json = await fetchResponse.json();
        // json.user.is_initial_user_login = true;
        console.log(json)
        if (
          'access_token' in json && typeof json.access_token === 'string' &&
          'session_id' in json && typeof json.session_id === 'string'
        ) {
          return json
        } else {
          throw new Error('json content not as expected')
        }
    } catch (e) {
        console.log("reqVampAccessToken error: " + JSON.stringify(e))
        throw new Error()
    }    
  }
  // requestProxyLogin("Teo", "pas2021!", AppConfig.proxyUrl)
  }, []); // Empty dependency array ensures this runs only once on component mount


  return (
    <div className="App">
      <AppStateContext.Provider value={appState}>
        <AppDispatchContext.Provider value={dispatch}>
        <DoLoginContext.Provider value={doLogin}>
          <PosteScreenWrapper initial={false}>
            <MainScreen />
          </PosteScreenWrapper>
        </DoLoginContext.Provider>
        </AppDispatchContext.Provider>
      </AppStateContext.Provider>
    </div>
  );
}

export default App;
